import axios from "axios";
import { FETCH_ALL_STOCKOPNAME_API } from "../Constants/Apis";

export const getStockOpnames = async () => {
  try {
    return axios.get(FETCH_ALL_STOCKOPNAME_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createStockOpname = async (payload) => {
  try {
    return axios.post(FETCH_ALL_STOCKOPNAME_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateStockOpname = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_STOCKOPNAME_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateSku = async (payload) => {
  try {
    return axios.put(`${FETCH_ALL_STOCKOPNAME_API}/update-sku`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateProductType = async (payload) => {
  try {
    return axios.put(`${FETCH_ALL_STOCKOPNAME_API}/update-pt`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteStockOpname = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_STOCKOPNAME_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

export const mutateStockOpname = async (payload) => {
  try {
    return axios.post(`${FETCH_ALL_STOCKOPNAME_API}/mutate`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const rejectStockOpname = async (ids) => {
  try {
    return axios.put(`${FETCH_ALL_STOCKOPNAME_API}/reject-update-bulk`, {
      ids,
    });
  } catch (e) {
    return console.log(e);
  }
};
